import { Flex } from 'antd';
import { useEffect, useState } from 'react';

interface SimpleDrawerProps {
    open: boolean;
    width?: number;
    children: React.ReactNode;
    offsetRight: number;
}

export const SimpleDrawer = ({ open, width = 300, children, offsetRight }: SimpleDrawerProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [inOffsetRight, setInOffsetRight] = useState(offsetRight);

    useEffect(() => {
        if (offsetRight < inOffsetRight) {
            setTimeout(() => {
                setInOffsetRight(inOffsetRight - 15);
            }, 5);
        }
    }, [offsetRight, inOffsetRight]);

    useEffect(() => {
        setIsOpen(open);
    }, [open]);

    return (
        <Flex
            style={{
                padding: 10,
                position: 'fixed',
                top: 0,
                right: inOffsetRight,
                width: width,
                height: '100vh',
                backgroundColor: '#fff',
                boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.2)',
                transform: isOpen ? `translateX(${0})` : `translateX(${width}px)`,
                transition: 'transform 0.3s ease',
                zIndex: 2000 - inOffsetRight,
                overflowY: 'auto',
            }}
            vertical
            justify={'space-between'}
        >
            {children}
        </Flex>
    );
};
